import { ref } from "vue";
import { useNuxtApp } from "#app";
import { collection, addDoc, serverTimestamp } from "firebase/firestore";

export function useContactForm() {
  const { $db } = useNuxtApp();
  const loading = ref(false);
  const error = ref(null);
  const sentId = ref(null);
  const inboxId = ref(null);

  async function send(payload) {
    error.value = null;
    sentId.value = null;
    inboxId.value = null;

    const name = payload?.name?.trim();
    const message = payload?.message?.trim();
    const phone = payload?.phone?.trim() || "";
    const phoneE164 = payload?.phoneE164 || "";

    if (!name || !message || !phoneE164) {
      error.value = new Error(
        "Заповніть обовʼязкові поля: імʼя, телефон, повідомлення.",
      );
      return null;
    }

    loading.value = true;
    try {
      const base = {
        name,
        phone,
        phoneE164,
        message,
        status: "new",
        source: payload?.source || "contacts-page",
        createdAt: serverTimestamp(),
      };

      // 1) основна колекція
      const mainRef = await addDoc(collection($db, "contactMessages"), base);
      sentId.value = mainRef.id;

      // 2) інбокс адмінки
      const ibRef = await addDoc(collection($db, "inbox"), {
        ...base,
        contactMessageId: mainRef.id,
      });
      inboxId.value = ibRef.id;

      return mainRef.id;
    } catch (e) {
      error.value = e;
      return null;
    } finally {
      loading.value = false;
    }
  }

  return { send, loading, error, sentId, inboxId };
}
